module.exports = __webpack_public_path__ + "static/banner-2-bb7815655a6e80b70cb49ebbf4b644c3.jpg";